// GENERADO por scripts/build-icons.ts — no editar a mano
export const ICON_PATHS: Record<string, string> = {
 "receipt": "<path d=\"M5 3h14v18l-2.500-1.500L14 21l-2-1.500L10 21l-2.500-1.500L5 21V3z\"/><path d=\"M8.500 8h7M8.500 12h7\"/>",
 "wine": "<path d=\"M7 3h10l-.5 6a4.500 4.500 0 0 1-9 0L7 3z\"/><path d=\"M12 13.500V21M8 21h8\"/>",
 "bulb": "<path d=\"M9 18h6M10 21h4M12 3a6 6 0 0 0-3.5 10.9c.6.5 1 1.2 1 2.1h5c0-.9.4-1.6 1-2.1A6 6 0 0 0 12 3z\"/>",
 "bed": "<path d=\"M3 19V6M3 15h18v4M21 15v-2a3 3 0 0 0-3-3h-8v5\"/><circle cx=\"6.5\" cy=\"11.5\" r=\"1.5\"/>",
 "cal": "<rect x=\"3\" y=\"5\" width=\"18\" height=\"16\" rx=\"2\"/><path d=\"M3 10h18M8 3v4M16 3v4\"/>",
 "scissors": "<circle cx=\"6\" cy=\"6\" r=\"2.500\"/><circle cx=\"6\" cy=\"18\" r=\"2.500\"/><path d=\"M8 7.500 20 18M8 16.500 20 6\"/>",
 "repeat": "<path d=\"M17 3l3 3-3 3\"/><path d=\"M4 11V9a3 3 0 0 1 3-3h13M7 21l-3-3 3-3\"/><path d=\"M20 13v2a3 3 0 0 1-3 3H4\"/>",
 "umbrella": "<path d=\"M3 12a9 9 0 0 1 18 0H3z\"/><path d=\"M12 12v6a2 2 0 0 0 4 0\"/>",
 "user": "<circle cx=\"12\" cy=\"8\" r=\"4\"/><path d=\"M4 21a8 8 0 0 1 16 0\"/>",
 "home": "<path d=\"M3 11 12 3l9 8\"/><path d=\"M5 10v10h14V10\"/>",
 "music": "<path d=\"M9 18V5l11-2v13\"/><circle cx=\"6\" cy=\"18\" r=\"3\"/><circle cx=\"17\" cy=\"16\" r=\"3\"/>",
 "calc": "<rect x=\"5\" y=\"3\" width=\"14\" height=\"18\" rx=\"2\"/><path d=\"M8 7h8v3H8zM8.500 14h.01M12 14h.01M15.500 14h.01M8.500 17.500h.01M12 17.500h.01M15.500 17.500h.01\"/>",
 "shirt": "<path d=\"M8 3 3 6l2.500 4L7 9v12h10V9l1.500 1L21 6l-5-3a4 4 0 0 1-8 0z\"/>",
 "ticket": "<path d=\"M3 7h18v3a2 2 0 0 0 0 4v3H3v-3a2 2 0 0 0 0-4V7z\"/><path d=\"M14 7v10\"/>",
 "tag": "<path d=\"M3 12V4h8l10 10-8 8L3 12z\"/><circle cx=\"7.5\" cy=\"8.5\" r=\"1\"/>",
 "spark": "<path d=\"M12 3l1.8 5.2L19 10l-5.2 1.8L12 17l-1.8-5.2L5 10l5.2-1.8z\"/>",
 "briefcase": "<rect x=\"3\" y=\"7\" width=\"18\" height=\"13\" rx=\"2\"/><path d=\"M9 7V5a1.500 1.500 0 0 1 1.500-1.500h3A1.500 1.500 0 0 1 15 5v2M3 13h18\"/>",
 "inbox": "<path d=\"M3 13h5l1 3h6l1-3h5\"/><path d=\"M5 5h14l2 8v6H3v-6l2-8z\"/>",
 "fuel": "<path d=\"M4 21V5a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v16M2.500 21h13M4 10h10M14 9h2a2 2 0 0 1 2 2v5a1.500 1.500 0 0 0 3 0V8l-2.500-2.500\"/>",
 "bike": "<circle cx=\"6\" cy=\"16\" r=\"3.500\"/><circle cx=\"18\" cy=\"16\" r=\"3.500\"/><path d=\"M6 16l4-8h5l3 8M10 8H8M13 8l-3 8\"/>",
 "paw": "<circle cx=\"6\" cy=\"10\" r=\"1.800\"/><circle cx=\"10\" cy=\"6\" r=\"1.800\"/><circle cx=\"14\" cy=\"6\" r=\"1.800\"/><circle cx=\"18\" cy=\"10\" r=\"1.800\"/><path d=\"M12 11c-3 0-5.500 3-5.500 5.500 0 2 1.500 2.500 3 2 1-.3 1.500-.5 2.500-.5s1.500.2 2.500.5c1.500.5 3 0 3-2C17.500 14 15 11 12 11z\"/>",
 "plane": "<path d=\"M2 14l9-3V5a1.500 1.500 0 0 1 3 0v6l8 3v2l-8-1.500V19l2.500 1.500V22L12 21l-4.500 1v-1.500L10 19v-4.500L2 16v-2z\"/>",
 "key": "<circle cx=\"8\" cy=\"15\" r=\"4\"/><path d=\"M11 12l9-9M16 7l3 3M14 9l2 2\"/>",
 "cart": "<circle cx=\"9\" cy=\"20\" r=\"1.5\"/><circle cx=\"18\" cy=\"20\" r=\"1.5\"/><path d=\"M2 3h3l2.6 12.4a1 1 0 0 0 1 .8h9.2a1 1 0 0 0 1-.8L21 7H6\"/>",
 "utensils": "<path d=\"M6 3v8M3 3v5a3 3 0 0 0 6 0V3M6 11v10M17 3c-2 2-3 5-3 8h3v10\"/>",
 "shield": "<path d=\"M12 3l8 3v6c0 4.500-3.500 8-8 9-4.500-1-8-4.500-8-9V6l8-3z\"/><path d=\"M9 12l2 2 4-4\"/>",
 "ball": "<circle cx=\"12\" cy=\"12\" r=\"9\"/><path d=\"M12 8l3.500 2.500-1.300 4h-4.400l-1.300-4L12 8zM12 3v5M20 9.500l-4.500 1M17 19l-2.800-4.500M7 19l2.800-4.500M4 9.500l4.500 1\"/>",
 "bolt": "<path d=\"M13 2 4 14h7l-1 8 9-12h-7z\"/>",
 "book": "<path d=\"M4 5a2 2 0 0 1 2-2h13v16H6a2 2 0 0 0-2 2zM4 19a2 2 0 0 1 2-2h13\"/>",
 "train": "<rect x=\"5\" y=\"3\" width=\"14\" height=\"14\" rx=\"3\"/><path d=\"M5 11h14M8 21l2-4M16 21l-2-4M9 14h.01M15 14h.01\"/>",
 "wallet": "<path d=\"M4 7h14a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H4a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1z\"/><path d=\"M4 7l11-3v3\"/><circle cx=\"16\" cy=\"13.5\" r=\"1\"/>",
 "bell": "<path d=\"M6 16v-5a6 6 0 0 1 12 0v5l2 2H4z\"/><path d=\"M10 21h4\"/>",
 "coffee": "<path d=\"M4 8h13v6a5 5 0 0 1-5 5H9a5 5 0 0 1-5-5zM17 10h2a2 2 0 0 1 0 4h-2M7 3v2M11 3v2\"/>",
 "cake": "<path d=\"M4 20h16v-7H4v7zM4 16.500c2 1.500 4 1.500 5.500 0s3.500-1.500 5 0 3 1.500 5.500 0\"/><path d=\"M12 13V9.500M12 6.500v.5\"/>",
 "tent": "<path d=\"M3 20 12 4l9 16H3z\"/><path d=\"M12 4v16M9 20l3-5 3 5\"/>",
 "wifi": "<path d=\"M2 9a15 15 0 0 1 20 0M5.5 12.5a10 10 0 0 1 13 0M9 16a5 5 0 0 1 6 0M12 19.5v.5\"/>",
 "card": "<rect x=\"3\" y=\"6\" width=\"18\" height=\"13\" rx=\"2\"/><path d=\"M3 10h18\"/>",
 "palette": "<path d=\"M12 3a9 9 0 1 0 0 18c1.500 0 2-1 1.500-2s0-2.500 1.500-2.500H17a4 4 0 0 0 4-4C21 6 17 3 12 3z\"/><path d=\"M7.500 11h.01M10 7h.01M15 7h.01\"/>",
 "bag": "<path d=\"M5 8h14l-1 12H6L5 8z\"/><path d=\"M9 8a3 3 0 0 1 6 0\"/>",
 "percent": "<path d=\"M19 5 5 19\"/><circle cx=\"7\" cy=\"7\" r=\"2.500\"/><circle cx=\"17\" cy=\"17\" r=\"2.500\"/>",
 "coin": "<circle cx=\"12\" cy=\"12\" r=\"9\"/><path d=\"M14.500 9.500c-.5-1-1.500-1.500-2.500-1.500-1.500 0-2.500.8-2.500 2s1 1.800 2.500 2 2.500.8 2.500 2-1 2-2.500 2c-1 0-2-.5-2.500-1.500M12 6.500V8M12 16v1.500\"/>",
 "baby": "<circle cx=\"12\" cy=\"12\" r=\"9\"/><path d=\"M9 10h.01M15 10h.01M9 15c1.500 1.500 4.500 1.500 6 0M12 3c1.500 0 2.500 1 2 2.500\"/>",
 "camera": "<path d=\"M4 8h3l1.500-2.500h7L17 8h3a1 1 0 0 1 1 1v9a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1z\"/><circle cx=\"12\" cy=\"13\" r=\"3.500\"/>",
 "bus": "<rect x=\"4\" y=\"4\" width=\"16\" height=\"13\" rx=\"3\"/><path d=\"M4 11h16M8 20v-3M16 20v-3M8 14h.01M16 14h.01\"/>",
 "leaf": "<path d=\"M5 19c0-9 5-14 15-14 0 10-5 15-14 15\"/><path d=\"M5 19c2-5 5-8 9-10\"/>",
 "star": "<path d=\"m12 3 2.7 5.6 6.1.9-4.4 4.3 1 6.1L12 17l-5.4 2.9 1-6.1L3.2 9.5l6.1-.9z\"/>",
 "sun": "<circle cx=\"12\" cy=\"12\" r=\"4\"/><path d=\"M12 2v2M12 20v2M2 12h2M20 12h2M5 5l1.500 1.500M17.500 17.500 19 19M19 5l-1.500 1.500M6.500 17.500 5 19\"/>",
 "pizza": "<path d=\"M3 6c6-3 12-3 18 0L12 21 3 6z\"/><circle cx=\"10\" cy=\"9\" r=\"1\"/><circle cx=\"14\" cy=\"11\" r=\"1\"/>",
 "hammer": "<path d=\"M13.500 5.500 18 10M4 20l9-9\"/><path d=\"M10.500 6.500l4-3.500 6 6-3.500 4-6.500-6.500z\"/>",
 "bank": "<path d=\"M3 9l9-5 9 5H3zM5 9v8M9.500 9v8M14.500 9v8M19 9v8M3 20h18\"/>",
 "pencil": "<path d=\"M4 20l1-4L16.500 4.500a2 2 0 0 1 3 3L8 19l-4 1z\"/><path d=\"M14.500 6.500l3 3\"/>",
 "phone": "<rect x=\"7\" y=\"2.5\" width=\"10\" height=\"19\" rx=\"2.5\"/><path d=\"M11 18.5h2\"/>",
 "dumbbell": "<path d=\"M6 8v8M18 8v8M3 10v4M21 10v4M6 12h12\"/>",
 "pill": "<rect x=\"3\" y=\"8.500\" width=\"18\" height=\"7\" rx=\"3.500\" transform=\"rotate(-45 12 12)\"/><path d=\"M9.500 9.500l5 5\"/>",
 "gift": "<rect x=\"3\" y=\"9\" width=\"18\" height=\"12\" rx=\"1\"/><path d=\"M12 9v12M3 13h18M12 9C9 9 8 4 11 4s1 5 1 5zm0 0c3 0 4-5 1-5s-1 5-1 5z\"/>",
 "car": "<path d=\"M5 16h14l-1.5-6.5A2 2 0 0 0 15.6 8H8.4a2 2 0 0 0-1.9 1.5L5 16z\"/><circle cx=\"8\" cy=\"18\" r=\"1.5\"/><circle cx=\"16\" cy=\"18\" r=\"1.5\"/>",
 "cap": "<path d=\"M2 9l10-5 10 5-10 5L2 9z\"/><path d=\"M6 11.500V16c0 1.500 3 3 6 3s6-1.500 6-3v-4.500M22 9v6\"/>",
 "globe": "<circle cx=\"12\" cy=\"12\" r=\"9\"/><path d=\"M3 12h18M12 3c3 3 3 15 0 18M12 3c-3 3-3 15 0 18\"/>",
 "cross": "<rect x=\"4\" y=\"4\" width=\"16\" height=\"16\" rx=\"3\"/><path d=\"M12 8v8M8 12h8\"/>",
 "laptop": "<rect x=\"5\" y=\"5\" width=\"14\" height=\"10\" rx=\"1.500\"/><path d=\"M2.500 19h19\"/>",
 "tooth": "<path d=\"M7 3c-2.500 0-4 2-4 4.500 0 3 1.500 4.500 2 7 .5 3 1 6 2.500 6 1.500 0 1.500-4 2.500-4s1 4 2.500 4c1.500 0 2-3 2.500-6 .5-2.500 2-4 2-7C19 5 17.500 3 15 3c-1.500 0-2 .8-3 .8S8.500 3 7 3z\"/>",
 "trend": "<path d=\"M3 17l6-6 4 4 8-8M15 7h6v6\"/>",
 "drop": "<path d=\"M12 3s6 6.5 6 11a6 6 0 0 1-12 0c0-4.5 6-11 6-11z\"/>",
 "parking": "<rect x=\"4\" y=\"4\" width=\"16\" height=\"16\" rx=\"3\"/><path d=\"M10 16V8h3a2.500 2.500 0 0 1 0 5h-3\"/>",
 "apple": "<path d=\"M12 8c-2-2-7-1-7 4s3 9 5 9c1 0 1.500-.5 2-.5s1 .5 2 .5c2 0 5-4 5-9s-5-6-7-4z\"/><path d=\"M12 8c0-2 1-4 3-5\"/>",
 "users": "<circle cx=\"9\" cy=\"8\" r=\"3.500\"/><path d=\"M2.500 20a6.500 6.500 0 0 1 13 0\"/><circle cx=\"17\" cy=\"9\" r=\"2.500\"/><path d=\"M17 14a5.500 5.500 0 0 1 4.500 6\"/>",
 "piggy": "<path d=\"M5 11a7 6 0 0 1 12.500-3.500L20 7v3.500l-1.500 1A6 6 0 0 1 17 15v3h-3v-1.500H9V18H6v-3.500A6 6 0 0 1 5 11z\"/><path d=\"M14.500 10.500h.01M9 6.500c1-1 3-1 4 0\"/>",
 "pulse": "<path d=\"M3 12h4l2.500-6 4 12 2.500-6h5\"/>",
 "gamepad": "<rect x=\"2.500\" y=\"7\" width=\"19\" height=\"11\" rx=\"5.500\"/><path d=\"M8 10v5M5.500 12.500h5M15.500 11.500h.01M18 13.500h.01\"/>",
 "film": "<rect x=\"3\" y=\"4\" width=\"18\" height=\"16\" rx=\"2\"/><path d=\"M7 4v16M17 4v16M3 9h4M3 15h4M17 9h4M17 15h4\"/>",
 "swap": "<path d=\"M4 8h14l-3-3M20 16H6l3 3\"/>",
 "heart": "<path d=\"M12 20s-8-5-8-11a4.5 4.5 0 0 1 8-2.8A4.5 4.5 0 0 1 20 9c0 6-8 11-8 11z\"/>"
};
export const ICON_META = [
 {
  "name": "cart",
  "label": "Súper",
  "group": "Compras y comida"
 },
 {
  "name": "bag",
  "label": "Compras",
  "group": "Compras y comida"
 },
 {
  "name": "utensils",
  "label": "Restaurantes",
  "group": "Compras y comida"
 },
 {
  "name": "coffee",
  "label": "Café",
  "group": "Compras y comida"
 },
 {
  "name": "pizza",
  "label": "Comida rápida",
  "group": "Compras y comida"
 },
 {
  "name": "wine",
  "label": "Bebidas",
  "group": "Compras y comida"
 },
 {
  "name": "apple",
  "label": "Frutas y verduras",
  "group": "Compras y comida"
 },
 {
  "name": "cake",
  "label": "Postres y fiestas",
  "group": "Compras y comida"
 },
 {
  "name": "car",
  "label": "Auto",
  "group": "Transporte"
 },
 {
  "name": "bus",
  "label": "Camión",
  "group": "Transporte"
 },
 {
  "name": "train",
  "label": "Tren y metro",
  "group": "Transporte"
 },
 {
  "name": "bike",
  "label": "Bici",
  "group": "Transporte"
 },
 {
  "name": "plane",
  "label": "Vuelos",
  "group": "Transporte"
 },
 {
  "name": "fuel",
  "label": "Gasolina",
  "group": "Transporte"
 },
 {
  "name": "parking",
  "label": "Estacionamiento",
  "group": "Transporte"
 },
 {
  "name": "home",
  "label": "Casa",
  "group": "Casa y servicios"
 },
 {
  "name": "bed",
  "label": "Hogar y descanso",
  "group": "Casa y servicios"
 },
 {
  "name": "bulb",
  "label": "Luz",
  "group": "Casa y servicios"
 },
 {
  "name": "drop",
  "label": "Agua",
  "group": "Casa y servicios"
 },
 {
  "name": "wifi",
  "label": "Internet",
  "group": "Casa y servicios"
 },
 {
  "name": "phone",
  "label": "Celular",
  "group": "Casa y servicios"
 },
 {
  "name": "key",
  "label": "Renta",
  "group": "Casa y servicios"
 },
 {
  "name": "hammer",
  "label": "Reparaciones",
  "group": "Casa y servicios"
 },
 {
  "name": "bolt",
  "label": "Energía",
  "group": "Casa y servicios"
 },
 {
  "name": "heart",
  "label": "Salud",
  "group": "Salud y bienestar"
 },
 {
  "name": "pill",
  "label": "Farmacia",
  "group": "Salud y bienestar"
 },
 {
  "name": "cross",
  "label": "Médico",
  "group": "Salud y bienestar"
 },
 {
  "name": "pulse",
  "label": "Chequeos",
  "group": "Salud y bienestar"
 },
 {
  "name": "dumbbell",
  "label": "Gym",
  "group": "Salud y bienestar"
 },
 {
  "name": "tooth",
  "label": "Dentista",
  "group": "Salud y bienestar"
 },
 {
  "name": "leaf",
  "label": "Bienestar",
  "group": "Salud y bienestar"
 },
 {
  "name": "sun",
  "label": "Vacaciones",
  "group": "Salud y bienestar"
 },
 {
  "name": "music",
  "label": "Música",
  "group": "Ocio y viajes"
 },
 {
  "name": "film",
  "label": "Cine y series",
  "group": "Ocio y viajes"
 },
 {
  "name": "gamepad",
  "label": "Videojuegos",
  "group": "Ocio y viajes"
 },
 {
  "name": "ticket",
  "label": "Eventos",
  "group": "Ocio y viajes"
 },
 {
  "name": "camera",
  "label": "Fotos",
  "group": "Ocio y viajes"
 },
 {
  "name": "palette",
  "label": "Arte y hobbies",
  "group": "Ocio y viajes"
 },
 {
  "name": "tent",
  "label": "Campamento",
  "group": "Ocio y viajes"
 },
 {
  "name": "ball",
  "label": "Deporte",
  "group": "Ocio y viajes"
 },
 {
  "name": "umbrella",
  "label": "Seguros",
  "group": "Ocio y viajes"
 },
 {
  "name": "globe",
  "label": "Viajes",
  "group": "Ocio y viajes"
 },
 {
  "name": "gift",
  "label": "Regalos",
  "group": "Ocio y viajes"
 },
 {
  "name": "wallet",
  "label": "Cartera",
  "group": "Dinero"
 },
 {
  "name": "card",
  "label": "Tarjeta",
  "group": "Dinero"
 },
 {
  "name": "bank",
  "label": "Banco",
  "group": "Dinero"
 },
 {
  "name": "coin",
  "label": "Efectivo",
  "group": "Dinero"
 },
 {
  "name": "piggy",
  "label": "Ahorro",
  "group": "Dinero"
 },
 {
  "name": "trend",
  "label": "Inversión",
  "group": "Dinero"
 },
 {
  "name": "receipt",
  "label": "Recibos",
  "group": "Dinero"
 },
 {
  "name": "percent",
  "label": "Intereses",
  "group": "Dinero"
 },
 {
  "name": "calc",
  "label": "Impuestos",
  "group": "Dinero"
 },
 {
  "name": "shield",
  "label": "Seguro",
  "group": "Dinero"
 },
 {
  "name": "swap",
  "label": "Transferencias",
  "group": "Dinero"
 },
 {
  "name": "repeat",
  "label": "Suscripciones",
  "group": "Dinero"
 },
 {
  "name": "briefcase",
  "label": "Trabajo",
  "group": "Trabajo y estudio"
 },
 {
  "name": "laptop",
  "label": "Freelance",
  "group": "Trabajo y estudio"
 },
 {
  "name": "cap",
  "label": "Estudios",
  "group": "Trabajo y estudio"
 },
 {
  "name": "book",
  "label": "Libros",
  "group": "Trabajo y estudio"
 },
 {
  "name": "pencil",
  "label": "Papelería",
  "group": "Trabajo y estudio"
 },
 {
  "name": "inbox",
  "label": "Pendientes",
  "group": "Trabajo y estudio"
 },
 {
  "name": "cal",
  "label": "Calendario",
  "group": "Trabajo y estudio"
 },
 {
  "name": "user",
  "label": "Personal",
  "group": "Personas y estilo"
 },
 {
  "name": "users",
  "label": "Familia",
  "group": "Personas y estilo"
 },
 {
  "name": "baby",
  "label": "Bebé",
  "group": "Personas y estilo"
 },
 {
  "name": "paw",
  "label": "Mascotas",
  "group": "Personas y estilo"
 },
 {
  "name": "shirt",
  "label": "Ropa",
  "group": "Personas y estilo"
 },
 {
  "name": "scissors",
  "label": "Belleza",
  "group": "Personas y estilo"
 },
 {
  "name": "spark",
  "label": "Antojos",
  "group": "Personas y estilo"
 },
 {
  "name": "star",
  "label": "Favoritos",
  "group": "Personas y estilo"
 },
 {
  "name": "tag",
  "label": "Otros",
  "group": "Personas y estilo"
 },
 {
  "name": "bell",
  "label": "Recordatorios",
  "group": "Personas y estilo"
 }
] as const;
